import { useEffect, useState } from "react";
import {  Row, Col, Modal, Tabs, Card, message, Layout, Typography,Tag , Select , Button ,  Checkbox, Input} from "antd";
import { 
  UserOutlined, 
  BankOutlined, 
  IdcardOutlined, 
  FileTextOutlined, 
  CheckCircleOutlined, 
  AppstoreOutlined, 
  SafetyCertificateOutlined 
} from "@ant-design/icons";
import kycVid from "../../assets/images/kyc/kycVideo.png";
import { ToastContainer,toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { getCourierSingleUser , approveunapproveCourierUser } from "../../api/login/Login";
import CustomInputField from "../../common/CustomInputField";
import { object } from "yup";
import { DocumentCard } from "../../components/distributer/createUserDistributer/kycDetails/KycDetails";
import { baseUrlImage, baseUrVideos } from "../../baseUrl";
import KycModals from "../../components/distributer/createUserDistributer/kycDetails/kycModals/KycModals";
const { Title } = Typography;
const { Content } = Layout;
const { Option } = Select;


const DocumentDetails = ({initialValues})=> {
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [previewModal, setPreviewModal] = useState({
    visible: false,
    image: null,
    title: ''
  });

  const handlePreview = (url, title) => {
    setPreviewModal({
      visible: true,
      image: url,
      title
    });
  };

  const imageTitles = {
    adhaarImgFront: 'Aadhaar Card Front',
    adhaarImgBack: 'Aadhaar Card Back',
    bankImg: 'Bank Document',
    panImg: 'PAN Card',
    shopFront: 'Shop Front',
    shopInnerImg: 'Shop Inner Image',
    shopLeftOfOuter: 'Left Outer View',
    shopRightOfOuter: 'Right Outer View',
    shopOuterImg: 'Shop Outer View',
    shopNearByImage: 'Nearby Shop Area',
  };

  const kycVideoSrc = initialValues?.kycVideo || initialValues?.kyc_video || initialValues?.docs?.kycVideo || initialValues?.docs?.kyc_video;

  const getThumbnailVideoUrl = (path) => {
    if (!path || typeof path !== 'string') return '';
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
    return `${baseUrVideos}${path}`;
  };

  return (
    <>
     <div className="p-4">
          <Card className="shadow-sm">
            <h3 className="mb-4 ">KYC Documentation</h3>
   <Row gutter={[24, 24]}>
          
              {Object?.entries(imageTitles)?.map(([key, title]) => (
     <Col xs={24} sm={12} lg={8} xl={6} key={key}>

   
      <DocumentCard
        title={title}
        imageSrc={
          initialValues?.[key] ? `${baseUrlImage}${initialValues[key]}` : null
        }
        dummyImage=""
        onClick={() => handlePreview(initialValues?.[key], title)}
      />
    </Col>
  ))}
   <Col xs={24} sm={12} lg={8} xl={6}>
            <Card className="h-100 shadow-sm" bodyStyle={{ padding: '12px' }}>
              <div className="text-center mb-3">
                <h5 className="fw-bold text-primary p-2 bg-light rounded">KYC Video</h5>
              </div>
              <div 
                className="position-relative cursor-pointer" 
                style={{ height: '200px', overflow: 'hidden' }}
                onClick={() => setVideoModalOpen(true)}
              >
                
                {kycVideoSrc ? (
                  <>
                    <video 
                      src={getThumbnailVideoUrl(kycVideoSrc)}
                      className="w-100 h-100 object-fit-cover"
                    />
                    <div className="position-absolute top-50 start-50 translate-middle">
                      <div className="play-btn"></div>
                    </div>
                  </>
                ) : (
                  <div className="h-100 d-flex flex-column justify-content-center align-items-center bg-light">
                    <img src={kycVid} alt="Video placeholder" className="mb-2" style={{ width: '64px' }} />
                    <p className="text-muted mb-0"><small>KYC Video Not Found</small></p>
                  </div>
                )}
              </div>
            </Card>
          </Col>

   <Col xs={24} sm={12} lg={8} xl={6}>
            <Card className="h-100 shadow-sm" bodyStyle={{ padding: '12px' }}>
              <div className="text-center mb-3">
                <h5 className="fw-bold text-primary p-2 bg-light rounded">Location Details</h5>
              </div>
              <div className="p-3">
                {initialValues?.longitude ? (
                  <>
                    <p className="mb-2">
                      <strong>Longitude: </strong>
                      {initialValues.longitude}
                    </p>
                    <p className="mb-0">
                      <strong>Latitude: </strong>
                      {initialValues.latitude}
                    </p>
                  </>
                ) : (
                  <p className="text-muted text-center mb-0">Location Not Found</p>
                )}
              </div>
            </Card>
          </Col>
            </Row>
            </Card>
            </div>

  
  <Modal
        open={previewModal.visible}
        visible={previewModal.visible}
        title={previewModal.title}
        footer={null}
        onCancel={() => setPreviewModal({ visible: false, image: null, title: '' })}
        width={800}
        centered
      >
        {previewModal.image && (
          <img
            src={`${baseUrlImage}${previewModal.image}`}
            alt={previewModal.title}
            style={{ width: '100%', height: 'auto' }}
          />
        )}
      </Modal>
      <KycModals 
        open={videoModalOpen}
        setOpen={setVideoModalOpen}
        kycVideo={kycVideoSrc || "KYC Videos Not Found"}
      />
    </>
  )
}




const SignUp = ({initialValues})=>{
  const businessDetails = [
    { label: "Full Name", value: initialValues.name },
    { label: "Father's Name", value: initialValues.father_name },
    { label: "Email", value: initialValues.email },
    { label: "Business Email", value: initialValues.Business_mail },
    // { label: "Profile Image", value: initialValues.profile },
    { label: "Year of Business Establishment", value: initialValues.yearOfBusinessPlace },
    { label: "Business Place Type", value: initialValues.businessPlaceType },
    { label: "Working Time", value: initialValues.workingTime },
    { label: "Working Days", value: initialValues.workingDays },
    { label: "Mobile Number", value: initialValues.mobile },
    { label: "Business Mobile", value: initialValues.business_mobile },
    // { label: "Sponsor ID", value: initialValues.sponsor_id },
    // { label: "Latitude", value: initialValues.latitude },
    // { label: "Longitude", value: initialValues.longitude },
    { label: "Aadhaar Number", value: initialValues.adhaar_number },
    { label: "PAN Number", value: initialValues.pan_number },
    { label: "PAN Name", value: initialValues.pan_name },
    { label: "Aadhaar Name", value: initialValues.adhaar_name },
    // { label: "Country", value: initialValues.country },
    { label: "State", value: initialValues.state },
    { label: "Present Address", value: initialValues.presentAddr },
    { label: "Shop Name", value: initialValues.shop_name },
    { label: "Business Address", value: initialValues.business_Address },
    { label: "Business Pincode", value: initialValues.business_pincode },
    { label: "Business City", value: initialValues.business_city },
    { label: "Business State", value: initialValues.business_state },
    { label: "Business Type", value: initialValues.businessType },
    { label: "Education Qualification", value: initialValues.educationQualification },
  ];
  
  return (
   <>
      <div className="p-4">
          <Card className="shadow-sm">
            <h3 className="mb-4 ">Registration Details</h3>
   <Row gutter={[24, 24]}>
   {businessDetails.map(({ label, value }, index) => (
   <Col xs={24} sm={12} lg={12} xl={8}>
  
   <CustomInputField
          type="text"
          placeholder={label}
          value={value || ''}
          id={label}
          name={label}
        />
   </Col>
     ))}
   </Row>
   </Card>
   </div>
  
   </>
  )
}


const  ApprovedArea = ({setResetKey , retailerInfo}) => {
   
  const params = useParams();
  const id = params?.id;
   const [checkBoxDisable, setCheckboxDisable] = useState(false);

  const [formData, setFormData] = useState({
    is_courierOnboarding: false,
    is_courierDoc: false,
    is_courierVideo: false,
    is_courierSingup: false,
    
    remark: "",
  });

  const handleApprovalChange = (value) => {
    if (value === true) {
      setCheckboxDisable(true);
      setFormData({
        ...formData,
        is_courierOnboarding: true,
        is_courierDoc: true,
        is_courierVideo: true,
        is_courierSingup: true,
      
        remark: "",
      });
    } else {
      setCheckboxDisable(false);
      setFormData({
        ...formData,
        is_courierOnboarding: false,
        remark: "",
      });
    }
  };

  const handleCheckboxChange = (key) => {
    setFormData((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleRemarkChange = (e) => {
    setFormData({ ...formData, remark: e.target.value });
  };

  const handleSubmit = async (action) => {
    try {
      const res = await approveunapproveCourierUser(formData, retailerInfo?._id); // Replace with actual API call
      if (res?.error === false) {
        message.success(res.message || `${action} action successful!`);
        setResetKey((pre)=>!pre)
      } else {
        message.error(res.message || `${action} action failed!`);
      }
    } catch (error) {
      console.error("Submission error:", error);
      message.error("An error occurred during submission.");
    }
  };

  const allChecked = Object.keys(formData)
    .filter((key) => key.startsWith("is_courier"))
    .every((key) => formData[key] === true);

  const atLeastOneUnchecked = Object.keys(formData)
    .filter((key) => key.startsWith("is_courier"))
    .some((key) => formData[key] === false);

  const isApproveButtonEnabled = formData.is_courierOnboarding === true && allChecked;
  const isUnapproveButtonEnabled =
    formData.is_courierOnboarding === false &&
    atLeastOneUnchecked &&
    formData.remark.trim().length > 0;

  useEffect(() => {
    if (retailerInfo?.is_courierOnboarding === true) {
      setCheckboxDisable(true);
    }
    setFormData((prev) => ({
      ...prev,
      is_courierOnboarding: retailerInfo?.is_courierOnboarding || false,
      is_courierDoc: retailerInfo?.is_courierDoc || false,
      is_courierVideo: retailerInfo?.is_courierVideo || false,
      is_courierSingup: retailerInfo?.is_courierSingup || false,
      remark: "",
    }));
  }, [retailerInfo]);

  return (
    <div className="approved-area">
      <h3>Courier Approval</h3>
      <Select
        style={{ width: "100%", marginBottom: "1rem" }}
        onChange={handleApprovalChange}
        value={formData?.is_courierOnboarding}
      >
        <Option disabled value="">Select Approval Status</Option>
        <Option value={true}>Approved</Option>
        <Option value={false}>Not Approved</Option>
      </Select>

      <div>
        {/* <Checkbox
          checked={formData.is_courierOnboarding}
          onChange={() => handleCheckboxChange("is_courierOnboarding")}
          disabled={checkBoxDisable}
        >
          Courier Onboarding
        </Checkbox> */}
        <Checkbox
          checked={formData.is_courierDoc}
          onChange={() => handleCheckboxChange("is_courierDoc")}
          disabled={checkBoxDisable}
        >
          Courier Document
        </Checkbox>
        <Checkbox
          checked={formData.is_courierVideo}
          onChange={() => handleCheckboxChange("is_courierVideo")}
          disabled={checkBoxDisable}
        >
          Courier Video
        </Checkbox>
        <Checkbox
          checked={formData.is_courierSingup}
          onChange={() => handleCheckboxChange("is_courierSingup")}
          disabled={checkBoxDisable}
        >
          Courier Signup
        </Checkbox>
        {/* <Checkbox
          checked={formData.is_courierAgreement}
          onChange={() => handleCheckboxChange("is_courierAgreement")}
          disabled={checkBoxDisable}
        >
          Courier Agreement
        </Checkbox> */}
      </div>

      {formData.is_courierOnboarding === false && (
        <Input
          placeholder="Enter Remark"
          value={formData.remark}
          onChange={handleRemarkChange}
          style={{ marginTop: "1rem" }}
        />
      )}

      <div style={{ marginTop: "1rem" }}>
        <Button
          onClick={() => handleSubmit("Approve")}
          disabled={!isApproveButtonEnabled}
          style={{ marginRight: "1rem" }}
        >
          Approve
        </Button>
        <Button
          onClick={() => handleSubmit("Unapprove")}
          disabled={!isUnapproveButtonEnabled}
        >
          Unapprove
        </Button>
      </div>
    </div>
  )
}

const CourierOnboardingUserVerify = () => {
  
  const [userDetails , setUserDetails] = useState('')
  const  { id }=  useParams()
  const [resetKey , setResetKey] = useState(false)


      const getUser = async()=>{
       
          let res = await getCourierSingleUser(id)
          console.log(res  , "res")
          if(res?.error === false)
          {
            setUserDetails(res?.data)
          }
      }


  useEffect(()=>{
    getUser()
  },[resetKey])

  const bankDetails = [
    { label: "Bank Name", value: userDetails?.bankDetails?.bank_name || '' },
    { label: "Account Number", value: userDetails?.bankDetails?.bank_account_number || '' },
    { label: "IFSC Code", value: userDetails?.bankDetails?.bank_ifsc || '' },
    { label: "Account Holder Name", value: userDetails?.bankDetails?.bank_account_name || '' },
  ]


  const items = [
    {
      key: "SponserDetails",
      label: (
        <span className="tab-label">
          <IdcardOutlined /> Sponsor Details
        </span>
      ),
      children: (
        <div className="tab-content">
           <div className="row">
  {userDetails?.sponsor && Object.keys(userDetails.sponsor).length > 0 ? (
    Object.keys(userDetails.sponsor).map((item, index) => (
      <div className="col-xl-4 mb-3" key={index}>
        <CustomInputField
          type="text"
          placeholder={item.charAt(0).toUpperCase() + item.slice(1)}
          value={userDetails.sponsor[item]}
          id={item}
          name={item}
        />
      </div>
    ))
  ) : (
    <div className="col-12">
      <p>User Signup without sponsor</p>
    </div>
  )}
</div>

        </div>
      ),
    },
    {
      key: "RegistrationDetails",
      label: (
        <span className="tab-label">
           <UserOutlined /> Registration Details
        </span>
      ),
      children: (
        <div className="tab-content">
           <SignUp initialValues={userDetails} />
        </div>
      ),
    },
    {
      key: "BankDetails",
      label: (
        <span className="tab-label">
           <BankOutlined /> Bank Details
        </span>
      ),
      children: (
        <div className="tab-content">
           {/* <SignUp initialValues={userDetails} /> */}
           <div className="p-4">
          <Card className="shadow-sm">
            <h3 className="mb-4 ">Bank Details</h3>
   <Row gutter={[24, 24]}>
   {bankDetails?.map(({ label, value }, index) => (
   <Col xs={24} sm={12} lg={12} xl={8}>
  
   <CustomInputField
          type="text"
          placeholder={label}
          value={value || ''}
          id={label}
          name={label}
        />
   </Col>
     ))}
   </Row>
   </Card>
   </div>
        </div>
      ),
    },
    {
      key: "DocumentDetails",
      label: (
        <span className="tab-label">
          <SafetyCertificateOutlined /> Document Details
        </span>
      ),
      children: (
        <div className="tab-content">
           <DocumentDetails initialValues={userDetails} />
        </div>
      ),
    },
 
    // {
    //   key: "AgreementDetails",
    //   label: (
    //     <span className="tab-label">
    //       <IdcardOutlined /> Agreement Details
    //     </span>
    //   ),
    //   children: (
    //     <div className="tab-content">
        
    //     </div>
    //   ),
    // },
 
  
 
  
   
    {
      key: "Approval",
      label: (
        <span className="tab-label">
          <CheckCircleOutlined /> Approval
        </span>
      ),
      children: (
        <div className="tab-content">
          <ApprovedArea setResetKey={setResetKey} retailerInfo ={userDetails?.users}/>
        </div>
      ),
    },
  
  ];
  return (
   <>
    <Layout className="main-layout">
      <Content>
        <div className="page-header">
          <Title level={4} className="page-title">
           Courier User Details
          </Title>
          <Tag 
            color={userDetails?.users?.is_courierOnboarding ? '#52c41a' : '#faad14'} 
            className="status-badge"
          >
            {userDetails?.users?.is_courierOnboarding ? 'Approved' : 'Pending'}
          </Tag>
        </div>

        <Card className="main-card">
          <Tabs
            defaultActiveKey="IdentifyVerification"
            items={items}
            destroyInactiveTabPane={true}
            animated={{
              tabPane: true,
            }}
            className="custom-tabs"
          />
        </Card>
      </Content>
      <ToastContainer />
    </Layout>
   
   </>
  )
}

export default CourierOnboardingUserVerify